export const userModes = ['direct', 'agent', 'staff', 'affiliate'] as const;
export type UserMode = 'direct' | 'agent' | 'staff' | 'affiliate';
